export const PRESET_QUERIES_TEMPLATES = {
  '0': 'select * from {table}',
  '1': 'select * from {table} where name = "{name}"',
  '2': 'select * from {table} where PID = {PID} and DateTime >= {timeFrom} and DateTime <= {timeTo}',
  '3': 'select * from {table} where remote_address = "{remoteAddress}"',
};
